// extracted by mini-css-extract-plugin
export default {"loader":"loadingSpinner_loader__jwMlG","rotation":"loadingSpinner_rotation__a6pop"};